export const UNNAMED_FAVOURITES: string[] = ['unnamed favourite', 'unnamed 2nd favourite'];
